import { useLocation, useNavigate, NavigateOptions } from '@reach/router';

import { useMemo } from 'react';

export interface SearchParamActions<T> {
  setValue: (s: T) => void;
  clear: () => void;
}

interface SearchParamOptions<T> {
  initialize: (s: string) => T;
}

export default function useArraySearchParam<T>(
  name: string,
  options: SearchParamOptions<T> & NavigateOptions<{}>
): [T, SearchParamActions<T>] {
  const location = useLocation();
  const navigate = useNavigate();

  const { initialize, ...navigationOptions } = options;

  const params = new URLSearchParams(location.search);
  const value = initialize(params.get(name) ?? '');

  const actions = useMemo(() => {
    const setValue = (s: T) => {
      params.set(name, (s as any).toString());

      navigate(`${location.pathname}?${params.toString()}`, navigationOptions);
    };
    const clear = () => {
      params.delete(name);

      navigate(`${location.pathname}?${params.toString()}`, navigationOptions);
    };

    return { clear, setValue };
  }, [name]);

  return [value, actions];
}
